















































































import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { ciCredit } from '~/icons/source/solid/credit'
import {
  defineComponent,
  toRefs,
  computed,
  useRoute
} from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import useStatic from '~/compositions/static'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { PromotedTier } from '~/models/classified/promoted'
import { useI18n } from '~/compositions/i18n'
import { useUserAgent } from '~/compositions/user-agent'
import { useDep } from '~/compositions/dependency-container'

export default defineComponent({
  components: { CImg },
  props: {
    tier: {
      type: Object,
      required: false,
      default: null
    },
    classified: { type: Object, required: true },
    actionPending: { type: Boolean, default: false },
    maxRefreshCount: { type: Number, default: 6 },
    preferredPayment: { type: String, default: 'credits' }
  },
  setup(props) {
    const { tier } = toRefs(props)
    const route = useRoute()
    const s = useStatic()
    const { isMobile } = useUserAgent()
    const { t, tc, locale } = useI18n()
    const legacyUrlService = useDep(LegacyUrlService)

    const buyCreditsUrl = computed(() =>
      route.value.path
        ? `${legacyUrlService.getBuyCreditsUrl()}?gotonext=${route.value.path}`
        : legacyUrlService.getBuyCreditsUrl()
    )

    const tierImg = computed(() =>
      s(
        `/nuxt-static/img/promotions/${isMobile.value ? 'mobile-' : ''}${
          tier.value.tier
        }${locale === 'en' ? '-en' : ''}.png`
      )
    )

    const tierTextClass = computed(() => {
      if (tier.value.tier === PromotedTier.TURBO) {
        return 'tw-text-promote-turbo'
      } else if (tier.value.tier === PromotedTier.SUPER) {
        return 'tw-text-green-500'
      }

      return 'tw-text-blue-600'
    })

    const promoInfo = computed(() => {
      if (tier.value.canBeBought) {
        return t('promo_info', {
          days: `${tier.value.days} ${tc(
            'day | days',
            tier.value.days
          ).toLowerCase()}`
        })
      }
      return t('make_your_classified_first')
    })

    return {
      tierImg,
      tierTextClass,
      ciCredit,
      PromotedTier,
      promoInfo,
      buyCreditsUrl
    }
  },
  i18n: defineComponentTranslations({
    promo_info: {
      en:
        'Your classified will be shown first for {days}, where it will be automatically renewed every 6 hours (for free) and, if there are other promoted classifieds, you will share the first position. You can cancel it at any time (no credits refunded).',
      el:
        'Η αγγελία σου θα εμφανίζεται πρώτη για {days}, όπου θα ανανεώνεται αυτόματα κάθε 6 ώρες (δωρεάν) και, αν υπάρχουν άλλες προωθημένες, θα μοιράζεσαι την πρώτη θέση. Μπορείς να την ακυρώσεις ανά πάσα στιγμή (χωρίς επιστροφή credits).'
    },
    not_enough_credits: {
      en:
        'You dont have <strong>enough</strong> paid credits to buy this promotion tier. You need <strong>{amount}</strong> more paid credits.',
      el:
        'Δεν έχεις αρκετά <strong>πληρωμένα</strong> credits για να αγοράσεις αυτό το επίπεδο προώθησης. Χρειάζεσαι ακόμα <strong>{amount}</strong> πληρωμένα credits.'
    },
    promo_details: {
      en: 'Promotion details',
      el: 'Λεπτομέριες προώθησης'
    },
    get_more: {
      en: 'Get more credits',
      el: 'Απόκτησε περισσότερα credits'
    },
    make_your_classified_first: {
      en: 'Buy credits and make your classified first.',
      el: 'Αγόρασε credits και κάνε την αγγελία σου πρώτη.'
    },
    buy_promo: {
      en: 'Buy promotion',
      el: 'Αγορά προώθησης'
    }
  })
})
